<template>
  <section class="gt-page">
    <div class="gt-page-inner compact">
      <div class="gt-card selector">
        <span class="gt-pill">Contexto operativo</span>
        <h1>Selecciona empresa</h1>
        <p class="gt-muted">Cada sesion trabaja dentro de una empresa y, cuando aplica, una sucursal.</p>

        <div class="company-list">
          <button v-for="company in companies" :key="company.token" class="company-item" :class="{ active: selectedCompany === company.token }" @click="selectedCompany = company.token">
            <strong>{{ company.name }}</strong>
            <small>{{ company.status }}</small>
          </button>
        </div>

        <div v-if="branches.length > 1" class="branch-box">
          <label class="gt-label">Sucursal</label>
          <select v-model="selectedBranch" class="gt-select">
            <option value="">Seleccion automatico</option>
            <option v-for="branch in branches" :key="branch.token" :value="branch.token">{{ branch.name }}</option>
          </select>
        </div>

        <button class="gt-button primary" :disabled="!selectedCompany || loading" @click="submit">
          {{ loading ? 'Cargando...' : 'Continuar' }}
        </button>
        <p v-if="error" class="error">{{ error }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'CompanySelectView',
  data() {
    return { selectedCompany: '', selectedBranch: '', loading: false, error: '' };
  },
  computed: {
    companies() { return this.$store.state.companies || []; },
    branches() { return this.$store.state.context?.branches || []; },
  },
  mounted() {
    if (this.companies.length === 1) this.selectedCompany = this.companies[0].token;
  },
  methods: {
    ...mapActions(['selectCompany']),
    async submit() {
      this.loading = true;
      this.error = '';
      try {
        const data = await this.selectCompany({ company_token: this.selectedCompany, branch_token: this.selectedBranch || undefined });
        if (data.context?.branches?.length > 1 && !data.context?.branch && !this.selectedBranch) {
          this.error = 'Selecciona una sucursal para continuar.';
          return;
        }
        this.$router.push(data.next_route || '/dashboard');
      } catch (error) {
        this.error = error.response?.data?.error || 'No se pudo seleccionar la empresa.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.compact { max-width: 760px; }
.selector { padding: 2rem; }
h1 { font-size: 2.4rem; margin: .8rem 0 .4rem; }
.company-list { display: grid; gap: .8rem; margin: 1.5rem 0; }
.company-item { border: 1px solid var(--gt-border); background: #fff; border-radius: 18px; padding: 1rem; text-align: left; cursor: pointer; }
.company-item strong { display: block; }
.company-item small { color: var(--gt-muted); }
.company-item.active { border-color: var(--gt-primary); box-shadow: 0 0 0 4px rgba(29,53,87,.08); }
.branch-box { margin-bottom: 1rem; }
.error { color: var(--gt-danger); font-weight: 800; }
</style>
